<template>
  <el-dialog
    :title="$t('productPriceRule.productPricing')"
    :visible.sync="dialogVisible"
    width="80%"
    @close="handleClose">
    <el-row :gutter="20">
      <el-col :span="8">
        <el-select
          v-model="updateProductPriceInfo.categoryId"
          :placeholder="$t('productPriceRule.selectProductCategory')"
          style="width:100%">
          <el-option
            v-for="item in updateProductPriceInfo.productCategorys"
            :key="item.categoryId"
            :label="item.categoryName"
            :value="item.categoryId">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="16">
        <el-input
          v-model="updateProductPriceInfo._currentProductName"
          :placeholder="$t('productPriceRule.inputProductName')">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="queryProducts">
          </el-button>
        </el-input>
      </el-col>
    </el-row>

    <el-table
      :data="updateProductPriceInfo.products"
      style="width:100%;margin-top:20px;"
      @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        width="55"
        align="center">
      </el-table-column>
      <el-table-column
        prop="prodName"
        :label="$t('productPriceRule.productName')"
        align="center">
      </el-table-column>
      <el-table-column
        prop="categoryName"
        :label="$t('productPriceRule.productCategory')"
        align="center">
      </el-table-column>
      <el-table-column
        prop="productId"
        :label="$t('productPriceRule.productId')"
        align="center">
      </el-table-column>
    </el-table>

    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next"
      :total="total"
      style="margin-top:20px;">
    </el-pagination>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="_updateProductPrice">{{ $t('productPriceRule.pricing') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { queryProduct, updateProductPrice, queryProductCategory } from '@/api/goods/productPriceRuleApi'

export default {
  name: 'UpdateProductPrice',
  data() {
    return {
      dialogVisible: false,
      currentPage: 1,
      pageSize: 15,
      total: 0,
      updateProductPriceInfo: {
        products: [],
        _currentProductName: '',
        productCategorys: [],
        categoryId: '',
        selectProducts: [],
        ruleId: ''
      }
    }
  },
  created() {
    this._listProductCategorys()
  },
  methods: {
    open(params) {
      this.updateProductPriceInfo.ruleId = params.ruleId
      this.dialogVisible = true
      this._loadAllProductInfo()
    },
    handleClose() {
      this.resetForm()
    },
    resetForm() {
      this.updateProductPriceInfo = {
        products: [],
        _currentProductName: '',
        categoryId: '',
        selectProducts: [],
        ruleId: ''
      }
      this.currentPage = 1
    },
    _listProductCategorys() {
      queryProductCategory({
        page: 1,
        row: 50,
        shopId: getShopId()
      }).then(response => {
        this.updateProductPriceInfo.productCategorys = response.data
      })
    },
    _loadAllProductInfo() {
      queryProduct({
        page: this.currentPage,
        row: this.pageSize,
        name: this.updateProductPriceInfo._currentProductName,
        categoryId: this.updateProductPriceInfo.categoryId
      }).then(response => {
        this.updateProductPriceInfo.products = response.data
        this.total = response.records
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._loadAllProductInfo()
    },
    handleSelectionChange(val) {
      this.updateProductPriceInfo.selectProducts = val.map(item => item.productId)
    },
    queryProducts() {
      this.currentPage = 1
      this._loadAllProductInfo()
    },
    _updateProductPrice() {
      if (this.updateProductPriceInfo.selectProducts.length === 0) {
        this.$message.warning(this.$t('productPriceRule.selectAtLeastOneProduct'))
        return
      }

      updateProductPrice({
        shopId: getShopId(),
        ruleId: this.updateProductPriceInfo.ruleId,
        productIds: this.updateProductPriceInfo.selectProducts.join(',')
      }).then(response => {
        console.log(response)
        this.$message.success(this.$t('common.operateSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      })
    }
  }
}
</script>